export default {
  on: true,
  cache: true,
  auth: true,
  intercept: false,
  title: '预分明细'
} as TCommon.RouteConfig
